import React, { VFC } from 'react';
import Image from 'next/image';

import { Button, ButtonSize, ButtonType, ButtonVariant } from 'components/Button';

import styles from './PartnerBox.module.scss';

interface IPartnerBox {
  title?: string;
  description?: string;
  href?: string;
  buttonText?: string;
  imageSrc: string;
  dataLayerEvent?: string;
}

export const PartnerBox: VFC<IPartnerBox> = ({
  title,
  description,
  href,
  buttonText,
  imageSrc,
  dataLayerEvent,
}) => (
  <dl className={styles['dl-wrapper']}>
    <div className={styles.imagesWrapper}>
      <Image src={imageSrc} layout="fill" objectFit="cover" />
    </div>
    <h2 className={styles.h2}>{title}</h2>
    <p>{description}</p>
    <Button
      type={ButtonType.Button}
      size={ButtonSize.Large}
      href={href}
      variant={ButtonVariant.PrimaryMintSweet}
      dataLayerEvent={dataLayerEvent}
    >
      {buttonText}
    </Button>
  </dl>
);
